import React from 'react';

const psSearch = (props) => {

  const handleSearch = (e) => {
    e.preventDefault();
    props.onChange(e.target.value)
  }

  return (
    <form className="col-md-auto">
      <div className="input-group input-group-round">
        <div className="input-group-prepend">
          <span className="input-group-text">
            <i className="material-icons">search</i>
          </span>
        </div>
        <input type="search"
               onChange={(e) => {handleSearch(e)}}
               className="form-control filter-list-input filter-search"
               onKeyPress={event => {
                 if (event.key === 'Enter') {
                   handleSearch(event)
                 }
               }}
               placeholder={props.placeholder} />
      </div>
    </form>
  )
};

export default psSearch;



// WEBPACK FOOTER //
// ./src/components/UI/PsSearch.js